module.exports = __webpack_public_path__ + "static/media/landscape_faceratio.53486e92.jpg";